var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"rbi rbi-gift"}),_vm._v(" "+_vm._s(_vm.$t('actionPages.orderTypes.gift'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }